import LinkItem from './LinkItem'
import LinkDialog from './LinkDialog'
import Draggable from 'vuedraggable'
import YesNoDialog from './../../../zzl-vue-component/YesNoDialog'

export default {
	name: 'SectionItemList',
	props: {
		value: {
			type: Object
		}
	},
	data() {
		const { items } = this.value
		return {
			maxItemId: items.reduce((max, item) => max < item.id ? item.id : max, 0),
			inAddItem: false,
			removeConfirmActive: false,
			removeItemIndex: null,
			removeItemTitle: null,
		}
	},
	components: {
		Draggable,
		LinkItem,
		LinkDialog,
		YesNoDialog,
	},
	template: `
		<Draggable class="index-section-items"
			v-model="value.items"
			draggable=".index-section-item"
			handle=".index-section-item-move-handle"
			chosen-class="index-section-item-chosen"
			ghost-class="index-section-item-ghost"
			:animation="200"
		>
			<div v-for="(item, index) in value.items" :key="item.id"
				class="index-section-item"
			>
				<div class="index-section-item-btn index-section-item-move-handle" title="ドラッグで移動">
					<span class="glyphicon glyphicon-move"></span>
				</div>
				<LinkItem v-model="value.items[index]"></LinkItem>
				<div class="index-section-item-btn index-section-item-remove-btn" title="この項目を削除"
					@click="removeItemConfirm(index)"
				>
					<span class="glyphicon glyphicon-remove"></span>
				</div>
			</div>
			<div class="index-section-item-add" @click="startAddItem">
				<span class="glyphicon glyphicon-plus"></span>
				リンクを追加
			</div>
			<LinkDialog v-if="inAddItem"
				@commit="addItem"
				@cancel="inAddItem = false"
			>
			</LinkDialog>
			<YesNoDialog title="リンク削除"
				v-if="removeConfirmActive"
				@yes="removeSelectedItem"
				@no="removeConfirmActive = false"
			>
				リンク「{{removeItemTitle}}」を削除してもよろしいですか？
			</YesNoDialog>
		</Draggable>
	`,
	methods: {
		startAddItem() {
			this.inAddItem = true
		},

		addItem(values) {
			this.value.items.push(Object.assign({}, values, {id: ++this.maxItemId}))
			this.inAddItem = false
		},

		removeItemConfirm(index) {
			this.removeItemIndex = index
			this.removeItemTitle = this.value.items[index].title
			this.removeConfirmActive = true
		},
		removeSelectedItem() {
			this.removeItem(this.removeItemIndex)
			this.removeConfirmActive = false
		},
		removeItem(index) {
			this.value.items.splice(index, 1)
		},
	}
}
